var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#702DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2841 8.36364L15.1364 16.6534H13.5625L13.4148 8.36364H15.2841ZM14.3523 20.108C14.0379 20.108 13.7689 19.9981 13.5455 19.7784C13.322 19.5549 13.2121 19.286 13.2159 18.9716C13.2121 18.661 13.322 18.3958 13.5455 18.1761C13.7689 17.9527 14.0379 17.8409 14.3523 17.8409C14.6591 17.8409 14.9242 17.9527 15.1477 18.1761C15.3712 18.3958 15.4848 18.661 15.4886 18.9716C15.4848 19.1799 15.4299 19.3712 15.3239 19.5455C15.2216 19.7159 15.0852 19.8523 14.9148 19.9545C14.7443 20.0568 14.5568 20.108 14.3523 20.108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.d94d82d5d312f6aadb7b7997327f054e.svg";
export { ForwardRef as ReactComponent };